import { UfoCustomTimingWrapper } from '@/components/signup/utils/ufo-custom-timing-wrapper';
import { ufoEventRedirectToProduct } from '@/components/signup/utils/ufo-events';
import { UfoCustomTimingKey } from '@/components/signup/utils/ufo.types';

import { UserSegmentationProvider } from './use-user-segmentation';
import ViewManager from './view-manager';

const UserSegmentation = () => {
	return (
		<UfoCustomTimingWrapper
			ufoEvent={ufoEventRedirectToProduct}
			ufoCustomTimingKey={UfoCustomTimingKey.JIRA_USER_SEGMENTATION_DWELL_TIME}
		>
			<div data-testid="user-segmentation">
				<UserSegmentationProvider>
					<ViewManager />
				</UserSegmentationProvider>
			</div>
		</UfoCustomTimingWrapper>
	);
};

export default UserSegmentation;
